import { iDocTextPolishMap } from './docTextPolish.type';

import {
  docTextPolishEffects,
  docTextPolishReducers,
} from './docTextPolish.operator';

export const docTextPolishInitData: iDocTextPolishMap = {};

// Model
export const docTextPolishModel = {
  state: docTextPolishInitData,
  reducers: docTextPolishReducers,
  effects: docTextPolishEffects,
};
